/**
 * Build an absolute URL to an in-app route, honoring the router base path.
 *
 * The app is served under a base path (e.g. "/app/") in the single-domain
 * topology; `import.meta.env.BASE_URL` reflects Vite's `base`. Using it here
 * keeps externally-visible URLs (Stripe redirects, share links) correct whether
 * the app is served at "/app" or at root ("/").
 *
 * @param {string} path - In-app path, with or without a leading slash.
 * @returns {string} e.g. "https://host/app/signup/checkout-return"
 */
export function appAbsoluteUrl(path = "") {
  const base = import.meta.env.BASE_URL || "/"; // "/app/" or "/"
  const cleanPath = String(path).replace(/^\//, "");
  return `${window.location.origin}${base}${cleanPath}`;
}
